export const globalDateFormatOptions = {
     month: '2-digit', 
     day: '2-digit', 
     year: 'numeric'
} as Intl.DateTimeFormatOptions